var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-header',{style:({ display: _vm.isHeaderShow ? 'block' : 'none' })},[_c('NavHeader')],1),_c('el-container',[_c('el-aside',{style:({ display: _vm.isAsideShow ? 'block' : 'none' }),attrs:{"width":"200px"}},[_c('NavAside')],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }